import { AddCircle, AddTask, ExpandMoreRounded } from "@mui/icons-material";
import { Button, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { ReactNode, useState } from "react";
import { ISurveyResponseAnswer } from "../models";
import { CreateIssueModal } from "./issues";
import { CreateTaskItemModal } from "./taskItems";
import { MaterialSymbolIcon, MaterialSymbols } from "./MaterialSymbolIcon";

interface IProps {
  startIcon?: ReactNode;
  text?: string;
  variant?: "tertiary" | "contained";
  context?: {
    teamName: string;
    teamSlug: string;
    actionItemGuid: string;
    actionItemDescription: string;
  };
  createdFromSurveyResponseAnswer?: ISurveyResponseAnswer;
  defaultSelectedTeamSlug?: string;
  onItemAdded?: () => void;
}

const AddIssueOrTaskButton = (props: IProps) => {
  const [addMenuAnchor, setAddMenuAnchor] = useState<HTMLElement | null>(null);
  const [isIssueModalVisible, setIsIssueModalVisible] = useState(false);
  const [isTaskItemModalVisible, setIsTaskItemModalVisible] = useState(false);

  function handleAddIssueClicked() {
    setAddMenuAnchor(null);
    setIsIssueModalVisible(true);
  }

  function handleAddTaskClicked() {
    setAddMenuAnchor(null);
    setIsTaskItemModalVisible(true);
  }

  function handleCreateIssueSettled() {
    setIsIssueModalVisible(false);
    props.onItemAdded?.();
  }

  function handleCreateTaskSettled() {
    setIsTaskItemModalVisible(false);
    props.onItemAdded?.();
  }

  return (
    <>
      <Button
        variant={props.variant ?? "tertiary"}
        startIcon={props.startIcon ?? <AddCircle />}
        endIcon={<ExpandMoreRounded />}
        sx={{ alignSelf: "start", whiteSpace: "nowrap" }}
        onClick={(e) => setAddMenuAnchor(e.currentTarget)}
      >
        {props.text ?? "Add"}
      </Button>

      <Menu
        anchorEl={addMenuAnchor}
        open={Boolean(addMenuAnchor)}
        onClose={() => setAddMenuAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={handleAddTaskClicked}>
          <ListItemIcon>
            <AddTask />
          </ListItemIcon>
          Add Task
        </MenuItem>
        <MenuItem onClick={handleAddIssueClicked}>
          <ListItemIcon>
            <MaterialSymbolIcon symbol={MaterialSymbols.QuickPhrases} />
          </ListItemIcon>
          Add Loop
        </MenuItem>
      </Menu>

      <CreateIssueModal
        visible={isIssueModalVisible}
        context={props.context}
        createdFromSurveyResponseAnswer={props.createdFromSurveyResponseAnswer}
        defaultSelectedTeamSlug={props.defaultSelectedTeamSlug}
        onCreated={handleCreateIssueSettled}
        onCancelled={handleCreateIssueSettled}
      />

      <CreateTaskItemModal
        visible={isTaskItemModalVisible}
        context={props.context}
        createdFromSurveyResponseAnswer={props.createdFromSurveyResponseAnswer}
        defaultSelectedTeamSlug={props.defaultSelectedTeamSlug}
        onCreated={handleCreateTaskSettled}
        onCancelled={handleCreateTaskSettled}
      />
    </>
  );
};

export { AddIssueOrTaskButton };
